<script lang="ts">
	import { GameCategory as CatalogGameCategory } from '@infinitro/catalog-min';
	import { GameCategory as GameCategoryLobby } from '@infinitro/game-category';
	import { SeoText } from '@infinitro/seo-text';
	import type { GameCategory } from '$lib/category';

	type SeoSection =
		| 'casino'
		| 'favorites'
		| 'featurebuyin'
		| 'gameshows'
		| 'home'
		| 'hotlive'
		| 'hotslots'
		| 'livecasino'
		| 'newgames'
		| 'populargames'
		| 'recentlyplayed'
		| 'slots'
		| 'tablegames';

	const categoryToSection: Record<GameCategory, SeoSection> = {
		casino: 'casino',
		favorites: 'favorites',
		featurebuyin: 'featurebuyin',
		gameshows: 'gameshows',
		hotlive: 'hotlive',
		hotslots: 'hotslots',
		livecasino: 'livecasino',
		newgames: 'newgames',
		populargames: 'populargames',
		recentlyplayed: 'recentlyplayed',
		slots: 'slots',
		table_games: 'tablegames'
	};

	export let data: { category: GameCategory };

	$: gameCategory = data.category as unknown as CatalogGameCategory;
	$: seoSection = categoryToSection[data.category];
</script>

<GameCategoryLobby {gameCategory}>
	<SeoText section={seoSection} noContainer />
</GameCategoryLobby>
